import { crmSystem } from "@/constants/crm/_shared/systems";
import { ConfigurationParameterInput } from "./ConfigurationParameterInput";
import { FullConfiguration } from "@/types/crm/configuration/configuration";
import { FullParameterData } from "@/types/crm/configuration/parameter";
import { UseFormReturn } from "react-hook-form";
import { selectedConfigurationSchema } from "@/lib/schema/configuration/configuration";
import { z } from "zod";

export const surveyParametersFormSchema = z.object({
    selected_configuration: selectedConfigurationSchema.optional().nullable().default(null),
});

export type SurveyParametersFormSchemaType = z.infer<typeof surveyParametersFormSchema>;

interface SurveyConfigurationParameterInputProps {
    crmSystem: crmSystem | undefined | null;
    parameters: FullParameterData[];
    form: UseFormReturn<SurveyParametersFormSchemaType>;
    fullConfiguration: FullConfiguration;
}

export function SurveyConfigurationParameterInput({
    crmSystem,
    parameters,
    form,
    fullConfiguration
}: Readonly<SurveyConfigurationParameterInputProps>) {
    const values = parameters.map((_, i) =>
        form.watch(`selected_configuration.parameter.${i}.value`) ?? undefined
    );

    const handleChange = (index: number, value: string | null | undefined) => {
        form.setValue(`selected_configuration.parameter.${index}.value`, value);
        form.setValue(`selected_configuration.parameter.${index}.id`, parameters[index]?.id);
    };

    return (
        <ConfigurationParameterInput
            crmSystem={crmSystem}
            parameters={parameters}
            values={values}
            onChange={handleChange}
            fullConfiguration={fullConfiguration}
        />
    );
}